import {Component, OnInit} from '@angular/core';

import {AppComponent} from '../app.component'

import {HttpService} from '../services/HttpService';
import {NotificationService} from '../services/NotificationService';

import swal from 'sweetalert2';

@Component({
    selector: 'app-swear-words',
    templateUrl: './swear-words.component.html',
    styleUrls: ['./swear-words.component.scss'],
    providers: [HttpService, NotificationService]
})
export class SwearWordsComponent implements OnInit {

    public sortValue: string = 'word';

    public reverse: boolean = false;

    public User_Details: any;
    public allWords: any;

    public addWord = {
        word: ''
    };

    constructor(
        public http: HttpService,
        public notification: NotificationService,
        public app: AppComponent,
    ) {
    }

    ngOnInit() {
        this.User_Details = JSON.parse(localStorage.getItem('Admin_User_Details'));
        this.app.loading = true;
        this.http.makeRequestPost(['super/user/swearword/get', {}])
        .subscribe(
            (resp) => {
                this.app.loading = false;
                if (resp.data) {
                    if (resp.data.length != 0) {
                        this.allWords = resp.data;
                    }
                    else {
                        this.notification.showNotification('There is no words to show', 'Error', 'error');
                    }
                }
                if (resp.error) {
                    this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                }
            },
            (error) => {
                this.app.loading = false;
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
            }
        )
    }

    addSwearWord() {
        this.app.loading = true;
        this.http.makeRequestPost(['super/user/swearword/create', this.addWord])
        .subscribe(
            (resp) => {
                this.app.loading = false;
                if (resp.data) {
                    this.addWord.word = '';
                    this.allWords.push(resp.data);
                }
                else {
                    this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                }
            },
            (error) => {
                this.app.loading = false;
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
            }
        )
    }

    deleteWord(word) {
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to delete this word?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            if (data.value) {

                this.app.loading = true;
                this.http.makeRequestPost(['super/user/swearword/delete', {id: word.id}])
                .subscribe(
                    (resp) => {
                        console.log(resp)
                        this.app.loading = false;
                        if (resp.data) {
                            for (var i = 0; i < this.allWords.length; i++) {
                                if (this.allWords[i].id == word.id) {
                                    this.allWords.splice(i, 1);
                                }
                            }
                        }
                        else {
                            this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }
        });

    }

}



// WEBPACK FOOTER //
// ./src/app/swear-words/swear-words.component.ts